import { render, staticRenderFns } from "./LabelList.vue?vue&type=template&id=153ea63d&scoped=true&"
import script from "./LabelList.vue?vue&type=script&lang=ts&"
export * from "./LabelList.vue?vue&type=script&lang=ts&"
import style0 from "./LabelList.vue?vue&type=style&index=0&id=153ea63d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153ea63d",
  null
  
)

export default component.exports